import { useFormik } from "formik";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import * as Yup from "yup";
import { selector } from "../../../api";
import { useEffect, useState } from "react";
import { kayaCRUD } from "../../../actions/kaya";
import { toast } from "react-toastify";

const regSchema = Yup.object().shape({
  kaya_id: Yup.string().required("This field is required"),
});

const initialValues = {
  is_closed: false,
  description: "",
  kaya_id: 0,
};

export const ChangeKaya = (props) => {
  const user = selector.User();

  const { index, setIndex, dataId } = props;

  const [kayaData, setKayaData] = useState([]);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setTimeout(() => {
      kayaCRUD
        .loadKayaData(10, 0, value, "")
        .then((resp) => {
          setKayaData(resp.data.results);
        })
        .finally(() => {});
    }, 500);
  }, [value]);

  const handleOnSearch = (string) => {
    setValue(string);
  };

  const formatResult = (kaya) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          {kaya.head_phone_number}
        </span>
      </>
    );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: regSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { is_closed, description, kaya_id } = values;
      const data = {
        is_closed,
        description,
        member_id: dataId,
        kaya_id,
        recorded_by: user.id,
      };
      setLoading(true);
      setTimeout(() => {
        kayaCRUD
          .memberChangeKaya(dataId, data)
          .then(() => {
            toast.success(
              "House hold member has been transfered successfully.",
              {
                autoClose: 7000,
              }
            );
            setIndex(index + 1);
            setLoading(false);
            setSubmitting(false);
            resetForm();
          })
          .catch((error) => {
            toast.error(error.message, { autoClose: 7000 });
            setLoading(false);
            setSubmitting(false);
          });
      }, 500);
    },
  });

  return (
    <>
      <div
        className="modal fade change"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="myLargeModalLabel">
                Shift House Member
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <hr />
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div class="mb-3">
                      <label for="kaya_id" class="form-label">
                        House hold <span className="text-danger">*</span>
                      </label>
                      <ReactSearchAutocomplete
                        items={kayaData}
                        onSearch={handleOnSearch}
                        onSelect={(e) => formik.setFieldValue("kaya_id", e.id)}
                        autoFocus
                        showItemsOnFocus={true}
                        styling={{
                          borderRadius: "4px",
                          height: "36px",
                          fontFamily: "Verdana, Arial, sans-serif",
                          fontSize: "0.8125rem",
                          fontWeight: 400,
                          zIndex: 100,
                        }}
                        inputDebounce={500}
                        placeholder={"Select House hold"}
                        showIcon={false}
                        formatResult={formatResult}
                        fuseOptions={{ keys: ["head_phone_number"] }}
                        resultStringKeyName={"head_phone_number"}
                      />
                      {formik.touched.head_phone_number &&
                        formik.errors.head_phone_number && (
                          <div
                            className="fw-light h6 mt-1"
                            style={{ fontSize: "15px" }}
                          >
                            <span role="alert" className="text-danger">
                              {formik.errors.head_phone_number}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label for="remarks" className="form-label">
                        Description{" "}
                      </label>
                      <textarea
                        type="text"
                        rows={5}
                        id="remarks"
                        {...formik.getFieldProps("description")}
                        className="form-control"
                        placeholder="Description"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="modal-footer">
                <a
                  href="javascript:void(0);"
                  class="btn btn-soft-danger fw-medium"
                  data-bs-dismiss="modal"
                >
                  <i class="ri-close-line me-1 align-middle"></i> Close
                </a>
                <button
                  type="submit"
                  className="btn btn-soft-success"
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && (
                    <span className="indicator-label">
                      <i className="las la-save la-lg"></i>save{" "}
                    </span>
                  )}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
